/**
 * Copyright (c) 2018
 * @summary Publishing the protocol setup modal popup
 * @author Ankur Vishwakarma,Poonam Banode,Mangesh Pimprikar,Irfan Bagwan
 */

import React, { Component } from 'react';
import { cloneDeep, findIndex } from 'lodash';
import { isArray } from 'lodash/lang';

import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../common/general/Button';
import ButtonGroup from '../../../../../common/general/ButtonGroup';
import NotificationManager from '../../../../../common/notifications/NotificationManager';
import TextFieldResolver from '../../../../../common/RichTextFormat/viewer/TextFieldResolver';
import { REASON_FOR_CHANGE_NEEDED } from '../../../../../constants/notificationMessages';

class ReasonForDataChangeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    this.setState({
      data: this.props.changedData.map(item => ({ reason: '', ...item }))
    });
  }

  onReasonChange = (e, index) => {
    const clone = cloneDeep(this.state.data);
    clone[index].reason = e.target.value;
    this.setState({
      data: clone
    });
  };

  validateSave = () => {
    return this.state.data.every(val => {
      return val.reason;
    });
  };

  onSaveReasons = () => {
    if (this.validateSave()) {
      const clone = cloneDeep(this.props.jsonForSave);
      this.state.data.forEach(val => {
        const index = findIndex(clone, data => {
          return data.elementEncounterIdentifier === val.id;
        });
        if (index > -1) {
          clone[index].reasonForDataChange = val.reason;
        }
      });
      this.props.onSave && this.props.onSave(clone);
    } else {
      NotificationManager.error(REASON_FOR_CHANGE_NEEDED);
    }
  };

  resolveStringValue = value => {
    if (this.isValidJsonAsString(value)) {
      const parsedFromJson = JSON.parse(value);

      if (isArray(JSON.parse(value))) {
        return parsedFromJson.join(', ');
      }
    }

    return value.toString();
  };

  isValidJsonAsString = str => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  render() {
    return (
      <>
        <ModalBoxes.Header>Item Changed</ModalBoxes.Header>
        <ModalBoxes.Body>
          <div className="row col-sm-12">
            <table className="table table-responsive-lg activity-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Previous</th>
                  <th>New</th>
                  <th>Reason</th>
                </tr>
              </thead>
              <tbody>
                {this.state.data.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <TextFieldResolver
                          fieldType={item.fieldType}
                          fieldName={item.name}
                          styledFieldName={item.styledFieldName}
                        />
                      </td>
                      <td>
                        {item.original == null || item.original === '' ? '--' : this.resolveStringValue(item.original)}
                      </td>
                      <td>{item.new == null || item.new === '' ? '--' : this.resolveStringValue(item.new)}</td>
                      <td>
                        <textarea value={item.reason} rows={2} onChange={e => this.onReasonChange(e, index)} />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </ModalBoxes.Body>
        <ModalBoxes.Footer>
          <ButtonGroup>
            <Button
              priority="medium"
              onClick={() => {
                this.props.modalBox.close();
                this.props.onClose();
              }}
            >
              CANCEL
            </Button>
            <Button onClick={this.onSaveReasons}>SAVE</Button>
          </ButtonGroup>
        </ModalBoxes.Footer>
      </>
    );
  }
}

export default ReasonForDataChangeModal;
